/** Grid-to-screen fragment shader. */

/** @todo Use a better setup than this, for tidier ongoing mapping tests. */
#define test_off 0
#define test_p2g 1
#define test_draw 2
#ifndef test
  #define test test_off
#endif

precision highp float;

#pragma glslify: Kernel2 = require(../kernel/kernel-2);

grid_useSamples
grid_useReads_mass

#ifdef grid_splits
  uniform sampler2D grid_states[grid_splits];
#else
  uniform sampler2D grid_states;
#endif

uniform float grid_stepNow;
uniform vec4 grid_stateShape;

uniform vec2 range;
uniform vec2 curve[4];
uniform vec4 colorLo;
uniform vec4 colorHi;

#ifdef angleHSLA
  uniform vec4 angleHSLA;
#endif

uniform vec2 aspect;

#ifdef rescale_motion
  uniform vec2 rescaleMotion;
#else
  const float rescaledMotion = 1.0;
#endif

varying vec2 grid_uv;

const vec2 v1 = vec2(1);
const vec2 v0 = v1*0.0;

#pragma glslify: lt = require(glsl-conditionals/when_lt);
#pragma glslify: map = require(glsl-map);

#ifdef angleHSLA
  #pragma glslify: hsl = require(glsl-hsl2rgb);
  #pragma glslify: pi = require(glsl-constants/PI);
#endif

#pragma glslify: offsetUV = require(@epok.tech/gl-gpgpu/src/lookup/offset-uv);

#pragma glslify: toKernel = require(../kernel/to-kernel);
#pragma glslify: toKernelOffset = require(../kernel/to-offset);
#pragma glslify: bezierXToY = require(../bezier/x-to-y, loopNewton=4);

#if defined(rescale_motion)
  #pragma glslify: exponent = require(../vector/exponent);
#endif

void main() {
  #ifdef rescale_motion
    float rescaledMotion = exponent(rescaleMotion);
  #endif

  vec2 motion = v0;
  /** Seems the right range, by trial, versus `[0, grid_stateShape.xy-1]`. */
  Kernel2 kernel = toKernel(grid_uv*grid_stateShape.xy);

  for(int gx = 0; gx < kernelSize; ++gx) {
    for(int gy = 0; gy < kernelSize; ++gy) {
      #if test == test_p2g
        // vec2 offset = toKernelOffset(vec2(gx, gy));
        // vec2 offset = toKernelOffset(vec2(kernelSize)*0.5);
        /** Range: `base` is `[0, grid_stateShape.xy-1.0]`, `st` is `[0, 1]`. */
        // vec2 st = (kernel.base+offset)/(grid_stateShape.xy-1.0);
        // vec2 st = kernel.base/(grid_stateShape.xy-1.0);
        // vec2 st = kernel.base/grid_stateShape.xy;
        // vec2 st = grid_uv;
        vec2 st = floor((grid_uv*grid_stateShape.xy)-0.5)/grid_stateShape.xy;

        // st = offsetUV(st, grid_stateShape.xy);
        // gl_FragColor.rgba = vec4(st, 0, 1);
        // return;
        grid_tapState(st);
        gl_FragColor.rgba = grid_data[0];

        // vec4 dc = grid_data[0]-vec4(st, 0.5, 1);

        // /** @todo With high scaling this is less accurate near axes cross. */
        // gl_FragColor.rgba = mix(vec4(0, 1, 0, 1), vec4(1, 0, 0, 1),
        //   clamp(dot(dc, dc)*1e3, 0.0, 1.0));
        return;
      #else
        float weight = kernel.weights[gx].x*kernel.weights[gy].y;
        vec2 offset = toKernelOffset(vec2(gx, gy));
        /** Range: `base` is `[0, grid_stateShape.xy-1.0]`, `st` is `[0, 1]`. */
        vec2 st = (kernel.base+offset)/(grid_stateShape.xy-1.0);

        st = offsetUV(st, grid_stateShape.xy);

        #if grid_stepsPast > 1
          for(int stepPast = 0; stepPast < grid_stepsPast; ++stepPast) {
            float ago = float(stepPast)/float(grid_stepsPast);

            grid_tapStateBy(offsetUV(st, grid_stateShape.xy), stepPast, 0);
            // grid_tapStateBy(st, stepPast, 0);

            motion += rescaledMotion*(1.0-ago)*weight*
              grid_data[grid_reads_mass_motionFull].grid_channels_motionFull;
              // grid_data[grid_reads_mass_motionFull].grid_channels_motionFull*
              // grid_data[grid_reads_mass_mass].grid_channels_mass;
              // vec2(grid_data[grid_reads_mass_mass].grid_channels_mass);
          }
        #else
          grid_tapState(offsetUV(st, grid_stateShape.xy));
          // grid_tapState(st);

          motion += rescaledMotion*weight*
            grid_data[grid_reads_mass_motionFull].grid_channels_motionFull;
            // grid_data[grid_reads_mass_motionFull].grid_channels_motionFull*
            // grid_data[grid_reads_mass_mass].grid_channels_mass;
            // vec2(grid_data[grid_reads_mass_mass].grid_channels_mass);
        #endif
      #endif
    }
  }

  // motion *= 1e9;

  #ifdef paceLinear
    float pace = length(motion);
  #else
    float pace = dot(motion, motion);
  #endif

  float at = clamp(map(pace, range.x, range.y, 0.0, 1.0), 0.0, 1.0);
  float to = bezierXToY(curve[0], curve[1], curve[2], curve[3], at);
  // float to = at;
  vec2 outside = lt(grid_uv, v0)+lt(v1, grid_uv);
  float on = lt(outside.x+outside.y, 0.5);
  vec4 color = mix(colorLo, colorHi, clamp(to, 0.0, on));

  #ifdef angleHSLA
    float hue = map(atan(motion.y, motion.x), -pi, pi, 0.0, 1.0);
    vec3 angleColor = hsl(fract(hue+angleHSLA.x), angleHSLA.y, angleHSLA.z);

    color.rgb = mix(color.rgb, angleColor, angleHSLA.a*on);
  #endif

  // #if test != test_off
  //   vec2 line = fract(grid_uv*grid_stateShape.xy);

  //   // color = mix(color, 1.0-color, lt(min(line.x, line.y), 5e-2));
  //   color = mix(color, vec4(1, 0, 0, 1), lt(min(line.x, line.y), 0.1));
  // #endif

  gl_FragColor = clamp(color, 0.0, 1.0);
  gl_FragColor.rgb *= gl_FragColor.a;
}
